const colors = {
  black: "#000000",
  white: "#ffffff",
  region1: "#CCB4B1",
  region2: "#E3B96A",
  region3: "#99ACB1",
  region4: "#D99C86",
  region5: "#CFB9C7",
  region6: "#A3B1C8",
  region7: "#8F9C7F",
  region8: "#D0B780",
  region1Lighter: "#e5d9d8",
  region2Lighter: "#f1dcb4",
  region3Lighter: "#ccd5d8",
  region4Lighter: "#eccdc2",
  region5Lighter: "#e7dce3",
  region6Lighter: "#d1d8e3",
  region7Lighter: "#c7cdbf",
  region8Lighter: "#e7dbbf",
  regionHover: "#003144",
  grey: "#3E4B59",
}

export default colors
